import React from "react";
import { Grid } from "@material-ui/core";
import "./App.css";
import { useState, useEffect } from "react";

import youtube from "./api/youtube";

import { SearchBar, VideoDetail, VideoList } from "./components/index";

//
window.onload = function () {
  function changeImage() {
    var BackgroundImg = [
      "https://images.unsplash.com/32/Mc8kW4x9Q3aRR3RkP5Im_IMG_4417.jpg?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1050&q=80",
      "https://images.unsplash.com/photo-1560355206-7bdbaa06ea8c?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1050&q=80",
      "https://images.unsplash.com/photo-1567095716798-1d95d8f4c479?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1050&q=80",
      "https://images.unsplash.com/photo-1545843505-da60809001ec?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=968&q=80",
      "https://images.unsplash.com/photo-1555344945-a8de57648a78?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=634&q=80",
      "https://images.unsplash.com/photo-1517524285303-d6fc683dddf8?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=675&q=80",
      "https://images.unsplash.com/photo-1549834174-30a98d600e5c?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=634&q=80",
      "https://images.unsplash.com/photo-1553356084-58ef4a67b2a7?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8OHx8dGV4dHVyZXxlbnwwfHwwfA%3D%3D&auto=format&fit=crop&w=300&q=60",
      "https://images.unsplash.com/photo-1584384689201-e0bcbe2c7f1d?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTF8fHRleHR1cmV8ZW58MHx8MHw%3D&auto=format&fit=crop&w=300&q=60",
      "https://images.unsplash.com/photo-1549490316-686f9b5d359f?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8MjJ8fHRleHR1cmV8ZW58MHx8MHw%3D&auto=format&fit=crop&w=300&q=60",
      "https://images.unsplash.com/photo-1572557798994-41431698dc8d?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8MjZ8fHRleHR1cmV8ZW58MHx8MHw%3D&auto=format&fit=crop&w=300&q=60",
      "https://images.unsplash.com/photo-1557672172-298e090bd0f1?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8Mjl8fHRleHR1cmV8ZW58MHx8MHw%3D&auto=format&fit=crop&w=300&q=60",
      "https://images.unsplash.com/photo-1578922427288-a47338083a57?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8MzJ8fHRleHR1cmV8ZW58MHx8MHw%3D&auto=format&fit=crop&w=300&q=60",
      "https://images.unsplash.com/photo-1487147264018-f937fba0c817?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8MzV8fHRleHR1cmV8ZW58MHx8MHw%3D&auto=format&fit=crop&w=300&q=60",
      "https://images.unsplash.com/photo-1566305977571-5666677c6e98?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8MXx8dGV4dHVyZXxlbnwwfHwwfA%3D%3D&auto=format&fit=crop&w=300&q=60",
      "https://images.unsplash.com/photo-1518640467707-6811f4a6ab73?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=800&q=80",
    ];
    let i = Math.floor(Math.random() * BackgroundImg.length);
    document.body.style.backgroundImage = 'url("' + BackgroundImg[i] + '")';
    // document.body.style.backgroundImage = 'url("images/1.jpg")';
  }
  window.setInterval(changeImage, 4000);
};

//
const App = () => {
  const [data, setData] = useState([]);
  const [query, setquery] = useState("");
  const [videos, setvideos] = useState([]);
  const [selectedVideo, setselectedVideo] = useState();

  useEffect(() => {
    const getData = async () => {
      if (query) {
        const {
          data: { items: vid },
        } = await youtube.get("search", {
          params: {
            part: "snippet",
            maxResults: 6,
            key: "AIzaSyCqOSIonX5BxuabgNImKHZXjBPffCBsYmc",
            q: query,
          },
        });
        setvideos(vid);
        setselectedVideo(vid[0]);
      }
    };

    getData();
  }, [query]);
  const onSelect = (vido) => {
    setselectedVideo(vido);
  };
  function handleChange(query) {
    setquery(query);
  }

  console.log(videos);
  return (
    <div class="container">
      <nav>
        <SearchBar onSubmit={handleChange} query={query} />
      </nav>
      <main id="main">
        <VideoDetail video={selectedVideo} />
      </main>
      <div id="sidebar">
        {/* <VideoItem /> */}
        <VideoList videos={videos} onVideoSelect={onSelect} />
      </div>
    </div>
  );
};

export default App;
